<template>
  <div class="page-container">
    <nav-bar></nav-bar>
    <div class="page">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="title-coontainer">
              <h5 class="card-title">Admins ({{ count }})</h5>
              <pager
                class="pager"
                :limit="limit"
                @onPageChanged="onPageChanged"
              ></pager>
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="onClickAddNewAdmin"
              >
                +
              </button>
            </div>

            <div class="empty" v-if="admins.length <= 0">
              <img src="../assets/empty.svg" />
              <span>No data to show ...</span>
            </div>

            <table class="table table-striped custom-table" v-else>
              <thead>
                <tr>
                  <th style="width: 5%" scope="col">ID</th>
                  <th style="width: 35%" scope="col">Name</th>
                  <th style="width: 20%" scope="col">Email</th>
                  <th style="width: 20%" scope="col">Access Level</th>
                  <th style="width: 20%" scope="col">Gender</th>
                  <th style="width: 40%" scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="admin.id" v-for="admin in admins">
                  <th scope="row">{{ admin.id }}</th>
                  <td>{{ admin.name }}</td>
                  <td>{{ admin.email }}</td>
                  <td>{{ admin.access_level }}</td>
                  <td style="text-transform: capitalize">
                    {{ admin.gender }}
                  </td>
                  <td style="display: grid">
                    <button
                      style="margin-left: 6px"
                      type="button"
                      class="btn btn-outline-danger"
                      @click="onClickDeleteAdmin(admin)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <single-item-creation-component
        v-if="showAdminCreationComponent"
        :schemtics="creationSchemetics"
        @success="adminCreationSuccess"
        @fail="adminnCreationFailed"
        @cancel="adminCreationCancelled"
      ></single-item-creation-component>

      <delete-item-modal
        :schemtics="adminDeleteSchemetics"
        v-if="showDeleteAdminModal"
        @success="onAdminDeleteSuccess"
        @cancel="onAdminDeleteCancelled"
      ></delete-item-modal>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { HTTP, URLS } from "../network/http";
import Pager from "../components/Pager";
var NotificationsController = require("../components/NotificationsController.js");
import SingleItemCreationComponent from "../components/SingleItemCreationComponent.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";

import moment from "moment";
export default {
  name: "admins",
  components: {
    NavBar,
    Pager,
    SingleItemCreationComponent,
    DeleteItemModal,
  },
  data() {
    return {
      resultsPerPage: 10,
      count: 0,
      page: 1,
      limit: 0,
      admins: [],
      showAdminCreationComponent: false,
      adminDeleteSchemetics: {},
      showDeleteAdminModal: false,
      creationSchemetics: {},
    };
  },
  methods: {
    onAdminDeleteCancelled() {
      this.showDeleteAdminModal = false;
      this.adminDeleteSchemetics = {};
    },
    onAdminDeleteSuccess() {
      this.showDeleteAdminModal = false;
      this.adminDeleteSchemetics = {};
      this.getAdmins();
    },
    onClickDeleteAdmin(admin) {
      let access_level = localStorage.getItem("access_level");
      if (access_level != 1) {
        this.$toast.error(
          "Only admin with access level 1 can delete other admins"
        );
        return;
      }
      let url = URLS.SUPER_ADMIN.BY_ID.replace(":id", admin.id);
      this.adminDeleteSchemetics = {
        endpoint: url,
        title: "Delete Admin",
        description: `Are you sure you want to delete <b> ${admin.name} </b> from the admins list ?`,
      };
      this.showDeleteAdminModal = true;
    },
    onClickAddNewAdmin() {
      this.creationSchemetics = {
        title: "Add New Admin",
        method: "post",
        endpoint: URLS.SUPER_ADMIN.REGISTER,
        fields: [
          {
            key: "name",
            title: "Name",
            placeholder: "Enter admin's name",
          },
          {
            key: "email",
            title: "Email",
            placeholder: "Enter admin email",
          },
          {
            key: "gender",
            title: "Gender",
            placeholder: "Select one gender",
            value: null,
            type: "single-option",
            options: ["male", "female", "other"],
          },
          {
            key: "access_level",
            title: "Access Level",
            placeholder: "Select one access level",
            value: null,
            type: "single-option",
            options: ["1", "2"],
          },
        ],
      };
      this.showAdminCreationComponent = true;
    },
    adminCreationSuccess(res) {
      this.showAdminCreationComponent = false;
      this.getAdmins();
    },
    adminCreationCancelled() {
      this.showAdminCreationComponent = false;
    },
    onPageChanged(page) {
      this.page = page;
      this.getAdmins();
    },
    getAdmins() {
      NotificationsController.showActivityIndicator();
      const ctx = this;
      var url = URLS.SUPER_ADMIN.LIST;
      url = url + "?limit=" + this.resultsPerPage;
      url = url + "&page=" + this.page;
      HTTP.get(url)
        .then((response) => {
          let data = response.data;
          let rows = data.rows;
          ctx.count = data.count;
          let limit = Math.ceil(data.count / ctx.resultsPerPage);
          ctx.limit = limit;
          ctx.previousEnable = limit > 0;
          ctx.nextEnable = ctx.page < limit;
          ctx.admins = rows;
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
  },
  mounted() {
    this.getAdmins();
    this.moment = moment;
  },
};
</script>

<style lang="scss">
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  nav-bar {
    height: 100px;
    width: 100%;
  }

  .page {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
  }

  .title-coontainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;

    .pager {
      margin-left: auto;
      margin-right: 1rem;
    }

    button {
      height: 3rem;
      font-size: 2rem;
      text-align: center;
      line-height: 1rem;
    }
  }
}

.table-card {
  box-shadow: 0px 0px 10px 0px #bdbdbd;
}

.filters-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  width: 100%;

  .input-group {
    display: flex;
    align-items: center;

    div {
      height: 100% !important;
    }

    input {
      height: 100% !important;
    }
  }

  .actions {
    margin-left: auto;
    width: 200px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    button {
      widows: 100px;
    }
  }
  // button{
  //   margin-left: 10px;
  // }
}
.actions {
  button {
    margin-right: 4px;
  }
}
</style>
